import { createTag } from "./createTag";

function loadStyleSheet(url) {
  return createTag('link', url, {
    type: "text/css",
    rel: "stylesheet",
  })
}

export default loadStyleSheet;